import { render, staticRenderFns } from "./FullWidth.vue?vue&type=template&id=2e01872b"
import script from "./FullWidth.vue?vue&type=script&lang=js"
export * from "./FullWidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports